<template>
  <div id="app">
    <navbar></navbar>
    <sign-in></sign-in>

    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import SignIn from './components/SignIn'

export default {
  name: 'app',
  components: { Navbar, SignIn },
  data () {
    return {
      
    }
  }
}
</script>

<style>
@font-face {
  font-family: GothamSSm;
  src: url(./../dist/14155.otf);
}
* {
  font-family: GothamSSm;
}


</style>



// WEBPACK FOOTER //
// src/App.vue